/**
 * Builds routing form responses for Cal.com based on member data.
 * These responses are passed to Cal.com to populate routing forms without displaying them to the user.
 */

/**
 * Determines if a member is based in Canada and returns the appropriate routing form response.
 * @param countryCode - The member's country of employment code (e.g., 'CA', 'US')
 * @returns An object with routing form field responses
 */
export function buildRoutingFormResponses(
  countryCode?: string
): Record<string, string> {
  const isBasedInCanada = countryCode === 'CA' ? 'Yes' : 'No'

  return {
    'is-Member-based-in-Canada': isBasedInCanada,
  }
}
